export const manifest = {
  screens: {
    scr_6nqmz5: { name: "Home", route: "/" },
  },
}
